export default __webpack_public_path__ + "static/media/gradientBorderSmall.5daaaaa7.svg";